import { LoginActionType } from '../constants/actionTypes';

const authReducer = (state = { authData: null }, action) => {
    switch(action.type) {
        case LoginActionType.AUTH:
        localStorage.setItem('profile', JSON.stringify({ ...action?.data }));
        return { ...state, authData: action?.data };
        case LoginActionType.LOGOUT:
            localStorage.clear();
            return { ...state, authData: null };
        default:
            return state;
    }
}

export default authReducer;
